<!-- @format -->

<template>
  <Row style="z-index: 0">
    <div
      v-if="props.useIndicator"
      :style="{
        left: `${currentTab * (100 / titles.length)}%`,
        width: `${100 / titles.length}%`,
      }"
      style="position: absolute; z-index: 1; height: 100%; transition: all 0.5s">
      <slot name="tabIndicator"></slot>
    </div>
    <div style="flex: 1; z-index: 2; height: 100%" v-for="(tab, index) in props.titles" @click="changeTab(index)" :key="tab">
      <slot name="tabItem" :title="tab" :index="index" :refIndex="currentTab"></slot>
    </div>
  </Row>
</template>
<script setup>
import { ref } from 'vue'
let emits = defineEmits(['onTabChanged'])
let props = defineProps({
  currentItem: {
    type: Number,
    default: 0,
  },
  useIndicator: { type: Boolean, default: true },
  titles: {
    type: Array,
    required: true,
  },
})
const currentTab = ref(props.currentItem)
function changeTab(index) {
  currentTab.value = index
  // console.log("tab changed:", index);
  emits('onTabChanged', currentTab.value)
}
</script>
